import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

//const api url from server
import baseUrl from '../base-url';
const API_URL = baseUrl()+"/api/all/";

const getRplBpk = 'sertifikasi-rpl';
const getDetailRplBPK = 'sertifikasi-rpl/';
const postRplBpkUrl = 'sertifikasi-rpl';
const deleteRplBpk = 'sertifikasi-rpl/delete-sertifikasi-rpl/';

class RplBpkService {
    getRplBpk(currentPage,pageSize,filter){
        return axios.get(
            API_URL + getRplBpk + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&kategoriRpl=BPK',
        {
            headers: authHeader()
        });
    }
    getDetailRplBPK(idSertifikasiRpl) {
        return axios.get(
            API_URL + getDetailRplBPK + idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    postRplBpk(formData) {
        return axios
            .post(
                API_URL + postRplBpkUrl,
                formData,
                { headers: authHeader() }
            );
    }

    deleteRplBpk(formData){
        return axios
        .delete(
            API_URL + deleteRplBpk + formData,
            { headers: authHeader() }
        );
    }


}

export default new RplBpkService();
